import * as apiGetUserSettingKeyV1 from 'api/userSetting/GetUserSettingKeyV1';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import { PreferredAllergen } from 'types/User/UserProfile/UserSettings';

export async function getUserAllergens(): Promise<PreferredAllergen[]> {
	const response = await apiGetUserSettingKeyV1.callApi('User.Allergens');
	return response.tryParseJson<PreferredAllergen[]>().getOrDefault([]);
}

const rb = new ReducerBuilder<PreferredAllergen[]>();
export const userAllergensLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'userAllergens/LoadedFromBackend'
);

export const setPreferredAllergens = rb.createActionForReducer(
	payloadReducer((x) => x),
	'userAllergens/SET'
);

export const userAllergensReducer = rb.createReducer();
